import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { IonInput, IonItem, IonLabel } from '@ionic/angular/standalone';
import { takeUntil } from 'rxjs/operators';
import { DestroyService } from 'src/app/services/destroy.service';
import { Status } from '../status';

@Component({
  selector: 'app-ssqw-input-form',
  templateUrl: './ssqw-input-form.component.html',
  styleUrls: ['./ssqw-input-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
  imports: [FormsModule, ReactiveFormsModule, IonLabel, IonInput, IonItem]
})
export class SsqwInputFormComponent implements OnInit {
  @Input() type: string;
  @Input() initial: string;
  @Input() required: boolean;
  @Input() clearEvent: EventEmitter<void>;
  @Output() status = new EventEmitter<Status>();
  @Output() inputClicked = new EventEmitter<HTMLElement>();

  field = new FormControl('');

  constructor(private destroy$: DestroyService) {}

  ngOnInit(): void {
    if (this.required) this.field.addValidators(Validators.required);
    if (this.type === 'text') this.field.addValidators(Validators.pattern(/^(?!\s+$).*/));
    if (this.type === 'email') this.field.addValidators(Validators.email);
    if (this.type === 'number') this.field.addValidators(this.numericValidator());
    this.field.statusChanges.pipe(takeUntil(this.destroy$)).subscribe((s) => {
      this.status.emit({
        valid: this.field.valid,
        errors: this.field.errors,
        value: this.field.value
      });
    });
    this.field.setValue(this.initial);
    this.clearEvent.pipe(takeUntil(this.destroy$)).subscribe(_ => this.field.setValue(''));
  }

  get length(): number {
    return this.field.value?.length ?? 0;
  }

  get autocorrect(): string {
    return this.type === 'text' ? 'on' : 'off';
  }

  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      (event.target as HTMLElement).blur();
    }
  }
  onKeyPress(event: KeyboardEvent): boolean {
    if (this.type === 'number' && event.key !== 'Enter') {
      const pattern = /^[-.\d]?$/;
      const result = pattern.test(event.key);
      return result;
    }
  }

  onClick(event: MouseEvent): void {
    this.inputClicked.emit(event.target as HTMLElement);
    // (event.target as HTMLElement).scrollIntoView();
  }

  numericValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      // Allow empty values (use required validator separately if needed)
      if (value === null || value === undefined || value === '') {
        return null;
      }

      // Check if value is a valid number
      const isNumeric = /^-?\d+(\.\d+)?$/.test(value);

      return isNumeric ? null : { numeric: true };
    };
  }
}
